<template>
  <!--  <img :src="adImgPath" alt="월간인사관리 광고문의" />-->
  <div v-html="editorContent"></div>
</template>

<script>
import {useMagazineStore} from '~/store/magazine/index.js'
import {useCommonStore} from '~/store/common/index.js'

export default {
  name: 'MagazineTab5',
  setup() {
    const store = useMagazineStore()
    const commonStore = useCommonStore()
    return {store, commonStore}
  },
  data() {
    return {
      editorContent: '',
      adImgPath: ''
    }
  },
  async mounted() {
    await this.getEditorBoard()
    // await this.getMagazineMain()
  },
  methods: {
    async getEditorBoard() {
      try {
        const payload = {
          parentType: 'magazine',
          type: '03'
        }
        const {data} = await this.commonStore.getEditorBoard(payload)
        this.editorContent = data.board?.content
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    async getMagazineMain() {
      try {
        const {data} = await this.store.getMagazineMain()
        this.adImgPath = data.adImgPath
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
